// 微信页面相关逻辑

import { jumpUrl, getArgByUrl } from "@utils/urlUtil";
import { isApplet } from "./env";

/**
 * 跳转页面 小程序tab | H5页面
 * @param link 链接
 */
export async function jump(link) {
    const reg = new RegExp("/page/home/index/index");
    let minitab;
    if (reg.test(link)) {
        minitab = parseInt(getArgByUrl(link, "tab")) || 0;
        if (isApplet) {
            wx.miniProgram.postMessage({
                data: {
                    homeOpt: {
                        tab: minitab
                    }
                }
            });
            wx.miniProgram.switchTab({
                url: "/page/home/index/index"
            });
        }
    } else jumpUrl(link, isApplet, true);
}
